import { Alert, Box } from '@mui/material';
import { PropsWithChildren, useContext } from 'react';
import FilterDisplay from 'shared/components/FilterDisplay';
import SaveButton from 'shared/components/SaveButton';
import { MassActionProps } from 'shared/types';

type MassActionModalLayoutProps<T> = PropsWithChildren<MassActionProps<T>> & {
    submitHandler: React.MouseEventHandler<HTMLButtonElement>;
};

export default function MassActionModalLayout<T>({
    isLoading,
    allRowsSelected,
    tableDataContext,
    rowCount,
    children,
    submitHandler,
    columnConfig
}: MassActionModalLayoutProps<T>) {
    const { filtersApplied } = useContext(tableDataContext);

    return (
        <>
            {
                <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{ pr: 2 }}>Number of rows<b>{ allRowsSelected ? ' NOT ' : ' ' }</b>affected:</Box>
                    <Box>{rowCount}</Box>
                </Box>
            }
            {
                !filtersApplied?.items.length &&
                <>
                    <Alert severity='warning'>No filters applied</Alert>
                </>
            }
            {!rowCount && !allRowsSelected && <Alert severity='error'>No affected rows</Alert>}
            {!!filtersApplied?.items.length && (
                <FilterDisplay
                    filtersApplied={filtersApplied}
                    columnConfig={columnConfig}
                    sx={{ mb: 2, pt: 2 }}
                />
            )}
            {children}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <SaveButton
                    submitHandler={submitHandler}
                    text='Apply'
                    isLoading={isLoading}
                    isDisabled={!rowCount && !allRowsSelected}
                />
            </Box>
        </>
    );
}
